<script setup>
import {usePortalContentAndDesignStore} from "../../../../stores/partners/portalContentAndDesignStore";

const portalContentAndDesignStore = usePortalContentAndDesignStore()

function updateStoreTranslations(selectedLanguage) {
    portalContentAndDesignStore.translationSettingsConfig.forEach((group) => {
        group.translations?.forEach((translationBlock) => {
            translationBlock.fields?.forEach?.((field) => {
                const key = field.setting;
                const newValue = field[selectedLanguage] ?? field.en;

                if (key && portalContentAndDesignStore.translationSettings.hasOwnProperty(key) && newValue) {
                    portalContentAndDesignStore.translationSettings[key] = newValue;
                }
            });
        });
    });
}

</script>

<template>
    <div class="bg-white border rounded p-4 mt-4 gap-12 space-y-3">
       <div class="text-sm text-gray-500">
           To translate standard phrases into another language, modify any of the fields below as needed.
           Alternatively, you may utilize predefined translations available through Partnero. This will update all
           the fields in the translation settings with the selected language.
        </div>
        <div>
            <select-field
                class="w-full"
                id="locale"
                name="locale"
                :model-value="portalContentAndDesignStore.selectedPredefinedLanguage"
                @update:model-value="updateStoreTranslations"
            >
                <option value="">Default</option>
                <option v-for="(translation) in portalContentAndDesignStore.availableTranslations" :value="translation.value">{{ translation.label }}</option>
            </select-field>
        </div>


    </div>
</template>

